import React, { useState, useEffect } from 'react'
import { getData } from '../../helpers/api';
import moment from 'moment';
import { useNavigate, useLocation } from 'react-router-dom'
import { EditorState } from 'draft-js';
import '../blog/index';

import {
    CBadge,
    CButton,
    CButtonGroup,
    CCard,
    CCardBody,
    CCardFooter,
    CCardHeader,
    CCol,
    CProgress,
    CRow,
    CCallout
} from 'compat/coreui'

export default function Blog(props) {
    const [orderData, setOrderData] = useState([])

    const navigate = useNavigate();
    const [userData, setUserData] = useState({})
    const [editorState, setEditorState] = useState(EditorState.createEmpty());
    const [showHours, setShowHours] = useState(false);
    const [businessName, setBusinessName] = useState("");
    const [businessType, setBusinessType] = useState("");
    const [businessEmail, setBusinessEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [webUrl, setWebUrl] = useState("");
    const [address, setAddress] = useState("");
    const [address2, setAddress2] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("");
    const [operationTime, setOperationTime] = useState("");
    const [pincode, setPincode] = useState("");
    const [fax, setFax] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [alternatePhone, setAlternatePhone] = useState("");
    const [alternateEmail, setAlternateEmail] = useState("");
    const [img, setImage] = useState("");

    useEffect(() => {
        getOrders()
    }, [])

    const getOrders = () => {
        getData(`${process.env.REACT_APP_APP_API_URL}/api/order`).then(res => {
            console.log(res)
            setOrderData(res.data.orders);
        }).catch(e => console.log(e))
    }

    const setPic = (selectedImg) => {
        console.log("Image---->>> ", selectedImg);
        setImage(URL.createObjectURL(selectedImg))
    }

    return (
        <>
            <section style={{ paddingTop: "10%", paddingBottom: "10%" }} className="blog-posts">
                <div className="blog_container">
                    <div className="blog_row for_mobile">
                        <div className="column_8">
                            <div className="all-blog-posts">
                                <div className="blog_row">
                                    <div className="column_12">
                                        <div className="blog-post">
                                            <div className="blog-thumb">
                                                <img src="https://templatemo.com/templates/templatemo_551_stand_blog/assets/images/blog-post-01.jpg" alt="" />
                                            </div>
                                            <div className="down-content">
                                                <span>Lifestyle</span>
                                                <a href="post-details.html"><h4>Best Template Website for HTML CSS</h4></a>
                                                <ul className="post-info">
                                                    <li><a href="#">Admin</a></li>
                                                    <li><a href="#">May 31, 2020</a></li>
                                                    <li><a href="#">12 Comments</a></li>
                                                </ul>
                                                <p>Stand Blog is a free HTML CSS template for your CMS theme. You can easily adapt or customize it for any kind of CMS or website builder. You are allowed to use it for your business. You are NOT allowed to re-distribute the template ZIP file on any template collection site for the download purpose. <a rel="nofollow" href="https://templatemo.com/contact" target="_parent">Contact TemplateMo</a> for more info. Thank you.</p>
                                                <div className="post-options">
                                                    <div className="blog_row">
                                                        <div className="column_6">
                                                            <ul className="post-tags">
                                                                <li><i className="fa fa-tags" /></li>
                                                                <li><a href="#">Beauty</a>,</li>
                                                                <li><a href="#">Nature</a></li>
                                                            </ul>
                                                        </div>
                                                        <div className="column_6">
                                                            <ul className="post-share">
                                                                <li><i className="fa fa-share-alt" /></li>
                                                                <li><a href="#">Facebook</a>,</li>
                                                                <li><a href="#"> Twitter</a></li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="column_12">
                                        <div className="blog-post">
                                            <div className="blog-thumb">
                                                <img src="https://templatemo.com/templates/templatemo_551_stand_blog/assets/images/blog-post-02.jpg" alt="" />
                                            </div>
                                            <div className="down-content">
                                                <span>Healthy</span>
                                                <a href="post-details.html"><h4>Etiam id diam vitae lorem dictum</h4></a>
                                                <ul className="post-info">
                                                    <li><a href="#">Admin</a></li>
                                                    <li><a href="#">May 24, 2020</a></li>
                                                    <li><a href="#">36 Comments</a></li>
                                                </ul>
                                                <p>You can support us by contributing a little via PayPal. Please contact <a rel="nofollow" href="https://templatemo.com/contact" target="_parent">TemplateMo</a> via Live Chat or Email. If you have any question or feedback about this template, feel free to talk to us. Also, you may check other CSS templates such as <a rel="nofollow" href="https://templatemo.com/tag/multi-page" target="_parent">multi-page</a>, <a rel="nofollow" href="https://templatemo.com/tag/resume" target="_parent">resume</a>, <a rel="nofollow" href="https://templatemo.com/tag/video" target="_parent">video</a>, etc.</p>
                                                <div className="post-options">
                                                    <div className="blog_row">
                                                        <div className="column_6">
                                                            <ul className="post-tags">
                                                                <li><i className="fa fa-tags" /></li>
                                                                <li><a href="#">Best Templates</a>,</li>
                                                                <li><a href="#">TemplateMo</a></li>
                                                            </ul>
                                                        </div>
                                                        <div className="column_6">
                                                            <ul className="post-share">
                                                                <li><i className="fa fa-share-alt" /></li>
                                                                <li><a href="#">Facebook</a>,</li>
                                                                <li><a href="#">Twitter</a></li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="column_12">
                                        <div className="blog-post">
                                            <div className="blog-thumb">
                                                <img src="https://templatemo.com/templates/templatemo_551_stand_blog/assets/images/blog-post-03.jpg" alt="" />
                                            </div>
                                            <div className="down-content">
                                                <span>Fashion</span>
                                                <a href="post-details.html"><h4>Donec tincidunt leo nec magna</h4></a>
                                                <ul className="post-info">
                                                    <li><a href="#">Admin</a></li>
                                                    <li><a href="#">May 14, 2020</a></li>
                                                    <li><a href="#">48 Comments</a></li>
                                                </ul>
                                                <p>Nullam at quam ut lacus aliquam tempor vel sed ipsum. Donec pellentesque tincidunt imperdiet. Mauris sit amet justo vulputate, cursus massa congue, vestibulum odio. Aenean elit nunc, gravida in erat sit amet, feugiat viverra leo. Phasellus interdum, diam commodo egestas rhoncus, turpis nisi consectetur nibh, in vehicula eros orci vel neque.</p>
                                                <div className="post-options">
                                                    <div className="blog_row">
                                                        <div className="column_6">
                                                            <ul className="post-tags">
                                                                <li><i className="fa fa-tags" /></li>
                                                                <li><a href="#">HTML CSS</a>,</li>
                                                                <li><a href="#">Photoshop</a></li>
                                                            </ul>
                                                        </div>
                                                        <div className="column_6">
                                                            <ul className="post-share">
                                                                <li><i className="fa fa-share-alt" /></li>
                                                                <li><a href="#">Facebook</a>,</li>
                                                                <li><a href="#">Twitter</a></li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="more_button">
                                        <div className="main-button">
                                            <a href="blog.html">View All Posts</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="column_4">
                            <div className="sidebar">
                                <div className="blog_row">
                                    <div className="column_12">
                                        <div className="sidebar-item search">
                                            <form id="search_form" name="gs" method="GET" action="#">
                                                <input type="text" name="q" className="searchText" placeholder="type to search..." autoComplete="on" />
                                            </form>
                                        </div>
                                    </div>
                                    <div className="column_12">
                                        <div className="sidebar-item recent-posts">
                                            <div className="sidebar-heading">
                                                <h2>Recent Posts</h2>
                                            </div>
                                            <div className="content">
                                                <ul>
                                                    <li><a href="post-details.html">
                                                        <h5>Vestibulum id turpis porttitor sapien facilisis scelerisque</h5>
                                                        <span>May 31, 2020</span>
                                                    </a></li>
                                                    <li><a href="post-details.html">
                                                        <h5>Suspendisse et metus nec libero ultrices varius eget in risus</h5>
                                                        <span>May 28, 2020</span>
                                                    </a></li>
                                                    <li><a href="post-details.html">
                                                        <h5>Swag hella echo park leggings, shaman cornhole ethical coloring</h5>
                                                        <span>May 14, 2020</span>
                                                    </a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="column_12">
                                        <div className="sidebar-item categories">
                                            <div className="sidebar-heading">
                                                <h2>Categories</h2>
                                            </div>
                                            <div className="content">
                                                <ul>
                                                    {/* <li><a href="#">- Nature Lifestyle</a></li>
                                                    <li><a href="#">- Awesome Layouts</a></li>
                                                    <li><a href="#">- Creative Ideas</a></li>
                                                    <li><a href="#">- Responsive Templates</a></li>
                                                    <li><a href="#">- HTML5 / CSS3 Templates</a></li>
                                                    <li><a href="#">- Creative &amp; Unique</a></li> */}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}